import React from "react";
import { useSnackbar } from "notistack";
import { snackBarMessage, snackBarVariant } from "../config";

export function useBlurbAction() {
  const [transition, setTransition] = React.useState(false);
  const [targetUrl, setTargetUrl] = React.useState("");
  const [showVideo, setShowVideo] = React.useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = React.useState("");
  const { enqueueSnackbar } = useSnackbar();

  const triggerTransition = (targetUrl, targetVideoUrl) => () => {
    console.log("Triggering transition to:", { targetUrl }, { targetVideoUrl });
    if (targetVideoUrl) {
      console.log("Playing video:", targetVideoUrl);
      // 如果有视频URL，播放视频
      setCurrentVideoUrl(targetVideoUrl);
      setShowVideo(true);
    } else if (targetUrl) {
      // 如果没有视频但有目标URL，直接跳转
      setTargetUrl(targetUrl);
      setTransition(true);
    } else {
      // 都没有则显示消息
      enqueueSnackbar(snackBarMessage, { variant: snackBarVariant });
    }
  };

  const handleVideoEnd = () => {
    console.log("handleVideoEnd Called");
    setShowVideo(false);
    setCurrentVideoUrl("");
    // // 视频播放完成后，如果有目标URL则跳转
    // if (targetUrl) {
    //   setTransition(true);
    // }
  };

  return {
    transition,
    targetUrl,
    showVideo,
    currentVideoUrl,
    triggerTransition,
    handleVideoEnd,
  };
}
